import { useQuery } from '@tanstack/react-query';
import api from '../lib/api';

// Interface definitions
export interface DailyUsage {
  date: string;
  premiumRequests: number;
  totalRequests: number;
  totalCost: number;
}

export interface UsageStatistics {
  totalPremiumRequests: number;
  totalRequests: number;
  totalCost: number;
  dailyUsage: DailyUsage[];
}

export interface UsageResponse {
  data: UsageStatistics;
}

// Function to fetch usage statistics
export const fetchUsageStatistics = async (
  month: string,
): Promise<UsageResponse> => {
  const response = await api.get(`/api/core/pleri/usage?month=${month}`);
  return response.data;
};

// React Query hook for usage statistics
export const useUsageStatistics = (month: string) => {
  return useQuery<UsageResponse, Error>({
    queryKey: ['pleri-usage', month],
    queryFn: () => fetchUsageStatistics(month),
    enabled: !!month && /^\d{4}-\d{2}$/.test(month), // Only fetch if month is provided and valid
    staleTime: 1000 * 60 * 5, // 5 minutes
  });
};
